import React from "react";
import { ArrowRight } from "lucide-react";

// Hard offset shadow primary button — matches scrapbook aesthetic
export const PrimaryButton = ({
    children,
    href,
    onClick,
    testId,
    className = "",
    icon = true,
    target,
    rel,
}) => {
    const Tag = href ? "a" : "button";
    return (
        <Tag
            data-testid={testId}
            href={href}
            onClick={onClick}
            target={target}
            rel={rel}
            className={`group inline-flex items-center justify-center gap-2 px-7 py-4 bg-ink text-white font-sans font-bold text-base sm:text-lg border-2 border-ink shadow-[6px_6px_0px_0px_rgba(224,82,54,1)] hover:translate-y-[2px] hover:translate-x-[2px] hover:shadow-[3px_3px_0px_0px_rgba(224,82,54,1)] active:translate-y-[4px] active:translate-x-[4px] active:shadow-[1px_1px_0px_0px_rgba(224,82,54,1)] transition-all duration-150 select-none ${className}`}
        >
            <span>{children}</span>
            {icon && (
                <ArrowRight
                    className="transition-transform group-hover:translate-x-1"
                    size={20}
                    strokeWidth={2.5}
                />
            )}
        </Tag>
    );
};

export const GhostButton = ({
    children,
    href,
    onClick,
    testId,
    className = "",
    target,
    rel,
}) => {
    const Tag = href ? "a" : "button";
    return (
        <Tag
            data-testid={testId}
            href={href}
            onClick={onClick}
            target={target}
            rel={rel}
            className={`inline-flex items-center justify-center gap-2 px-6 py-3 bg-transparent text-ink font-sans font-semibold text-base border-b-2 border-ink/30 hover:border-marker-red hover:text-marker-red transition-colors ${className}`}
        >
            {children}
        </Tag>
    );
};

export default PrimaryButton;
